import React from "react";
import Layout from "../Landing/Layout";
import aboutSection from "../Landing/assets/about-section.png";
import geometricArchitecture from "../Landing/assets/geometric-architecture.jpg";

const About = () => {
  return (
    <Layout>
      <section className="page-hero about-hero">
        <div className="section-container animate-fade-in-up">
          <div className="grid-12">
            <div className="lg:col-span-12">
              <p className="label-text text-muted-foreground mb-4">FIRM OVERVIEW</p>
              <h1 className="heading-display mb-8">ABOUT DOUGLAS & McCARTNEY</h1>

              <div className="mb-12 image-frame hero-image-frame">
                <img
                  src={aboutSection}
                  alt="About Douglas & McCartney - City skyline"
                  className="w-full h-auto"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                  sizes="100vw"
                />
              </div>

              <div className="space-y-6 text-center text-measure mx-auto">
                <p className="body-text text-muted-foreground">
                  Douglas & McCartney operates as a structured real estate advisory platform focused on professionalizing how advisory businesses function.
                </p>
                <p className="body-text text-muted-foreground">
                  The real estate market is complex, relationship-driven, and highly fragmented. While opportunity exists, advisory practices often remain informal and overly dependent on individuals rather than systems.
                </p>
                <p className="body-text text-muted-foreground">
                  Douglas & McCartney addresses this gap by enabling professionals to operate within a structured platform - without compromising independence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-band section-divider">
        <div className="section-container">
          <div className="grid-12">
            <div className="lg:col-span-8 lg:col-start-3">
              <div className="section-header text-center">
                <h2 className="heading-section mb-4">Our Approach</h2>
                <p className="body-text text-muted-foreground text-measure mx-auto">
                  Douglas & McCartney is built around a simple principle:
                </p>
              </div>

              <div className="space-y-6">
                <p className="heading-subsection text-center italic text-measure mx-auto font-semibold">
                  Professional advisory businesses grow sustainably when supported by systems, structure, and long-term alignment.
                </p>

                <div className="pt-8">
                  <h3 className="heading-subsection heading-mid mb-6 text-center">The platform emphasizes:</h3>
                  <ul className="space-y-4 text-center">
                    <li className="body-text flex items-center justify-center gap-3 text-center">
                      <span className="text-accent font-bold">&rsaquo;</span>
                      Defined advisory frameworks
                    </li>
                    <li className="body-text flex items-center justify-center gap-3 text-center">
                      <span className="text-accent font-bold">&rsaquo;</span>
                      Process discipline and governance
                    </li>
                    <li className="body-text flex items-center justify-center gap-3 text-center">
                      <span className="text-accent font-bold">&rsaquo;</span>
                      Clear positioning and credibility
                    </li>
                    <li className="body-text flex items-center justify-center gap-3 text-center">
                      <span className="text-accent font-bold">&rsaquo;</span>
                      Continuous professional development
                    </li>
                  </ul>
                </div>

                <p className="body-text text-muted-foreground text-measure mx-auto pt-4 text-center">
                  Rather than positioning brokers as isolated operators, Douglas & McCartney supports them as professional advisors within a broader ecosystem.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-surface section-divider">
        <div className="section-container">
          <div className="section-header text-center">
            <h2 className="heading-section mb-4">Platform Led, Not Personality Led</h2>
            <p className="body-text text-muted-foreground text-measure mx-auto">
              Douglas & McCartney is intentionally designed to be platform-led.
            </p>
          </div>

          <div className="grid-12 items-center">
            <div className="image-frame lg:col-span-6">
              <img
                src={geometricArchitecture}
                alt="Modern geometric glass architecture"
                className="w-full h-auto"
                loading="lazy"
                decoding="async"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
            <div className="space-y-6 lg:col-span-6">
              <p className="body-text text-muted-foreground">
                While experience and leadership matter, the platform does not rely on personalities or informal practices. Instead, it prioritizes:
              </p>
              <ul className="space-y-3">
                <li className="body-text flex items-start gap-3">
                  <span className="text-accent font-bold">&rsaquo;</span>
                  Consistency over charisma
                </li>
                <li className="body-text flex items-start gap-3">
                  <span className="text-accent font-bold">&rsaquo;</span>
                  Governance over improvisation
                </li>
                <li className="body-text flex items-start gap-3">
                  <span className="text-accent font-bold">&rsaquo;</span>
                  Systems over shortcuts
                </li>
                <li className="body-text flex items-start gap-3">
                  <span className="text-accent font-bold">&rsaquo;</span>
                  Longevity over short-term outcomes
                </li>
              </ul>
              <p className="body-text text-muted-foreground pt-4">
                This approach allows advisory businesses to remain resilient, credible, and scalable.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
